<template>
  <div>
    <global-menu :menuType="1"/>
  </div>
</template>

<script>
import GlobalMenu from "@/components/page/GlobalMenu";
import store from '@/store'

export default {
  name: "MainMenu",
  components: {GlobalMenu},
  created: function () {
    store.commit("SET_MENU_VISIBLE", true)
  }
}
</script>

<style scoped>

</style>
